import React, { useMemo } from 'react'
import { BtRadioGroup } from '@linqpal/components/src/ui'

const Type = ({ model, value }) => {
  const radioButtons = useMemo(() => {
    const options = [
      { label: 'Private', value: 'private' },
      { label: 'Public', value: 'public' },
      { label: 'Federal', value: 'federal' },
    ]
    return (
      <BtRadioGroup
        value={value}
        options={options}
        onChange={(val) => model.setValue(val)}
        radioStyle={{ marginRight: 32 }}
        groupStyle={{ flexDirection: 'row' }}
        labelStyle={{ color: '#19262F', fontWeight: '500', fontSize: 16 }}
        testID="businessOwner_isAuthorized"
      />
    )
  }, [model, value])
  return radioButtons
}

export default {
  identifier: 'type',
  title: '',
  component: Type,
  shouldProcessAnswer: true,
  optional: true,
}
